import { DATA_STATE_VALID, DATA_STATE_INVALID } from '../../constants';
export const constants = Object.freeze({
    NAME: 'RadioButtonGroup',
    variants: {
    // to be defined
    },
    dataStates: {
        DATA_STATE_VALID,
        DATA_STATE_INVALID,
    },
});
export default function getRadioButtonGroup() {
    return Object.freeze({
        constants,
    });
}
